module.exports = __webpack_public_path__ + "img/wallet_mob.png";